export default "__VITE_ASSET__BsTGFVmw__"